import { Clock } from 'lucide-react';
import type { AgendaHours } from '../lib/useAgendaHours';

// C-4 — Control del rango horario de la agenda (presentacional). Dos selects
// "Desde"/"Hasta"; al cambiar emite un rango SIEMPRE válido (si el inicio pisa al
// fin, empuja el fin a inicio+1) → guardar refleja de inmediato en la rejilla.
interface Props {
  start: number;
  end: number;
  onChange: (h: AgendaHours) => void;
  disabled?: boolean;
}

function pad(h: number): string {
  return `${String(h).padStart(2, '0')}:00`;
}

export default function AgendaHoursControl({ start, end, onChange, disabled }: Props) {
  const startOptions = Array.from({ length: 24 }, (_, i) => i); // 0..23
  const endOptions = Array.from({ length: 24 }, (_, i) => i + 1).filter((h) => h > start); // start+1..24

  return (
    <div
      data-testid="agenda-hours-control"
      className="flex items-center gap-2 text-sm font-inter text-text-secondary"
    >
      <Clock size={14} className="text-gold-primary" />
      <span className="hidden sm:inline">Horario</span>
      <select
        data-testid="agenda-hours-start"
        aria-label="Hora de inicio de la agenda"
        value={start}
        disabled={disabled}
        onChange={(e) => {
          const s = Number(e.target.value);
          onChange({ start: s, end: Math.max(end, s + 1) });
        }}
        className="bg-bg-surface border border-bg-border rounded-lg px-2 py-1 text-white focus:border-gold-primary/50 outline-none"
      >
        {startOptions.map((h) => (
          <option key={h} value={h}>
            {pad(h)}
          </option>
        ))}
      </select>
      <span>–</span>
      <select
        data-testid="agenda-hours-end"
        aria-label="Hora de fin de la agenda"
        value={end}
        disabled={disabled}
        onChange={(e) => onChange({ start, end: Number(e.target.value) })}
        className="bg-bg-surface border border-bg-border rounded-lg px-2 py-1 text-white focus:border-gold-primary/50 outline-none"
      >
        {endOptions.map((h) => (
          <option key={h} value={h}>
            {pad(h)}
          </option>
        ))}
      </select>
    </div>
  );
}
